<canvas
  #confettiCanvas
  class="confetti-canvas">
</canvas>

